"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveBanner = void 0;
const react_1 = __importStar(require("react"));
const commons_1 = require("../commons");
const use_elements_props_1 = require("../hooks/use-elements-props");
const use_tracking_event_listener_1 = require("../hooks/use-tracking-event-listener");
const EmptyStyle = {};
const HiddenStyle = {
    width: '1px',
    height: '1px',
    visibility: 'hidden'
};
const AdditionalIframeProps = {
    allowtransparency: 'false',
    importance: 'high'
};
function calcIframeHeight(iframeBody) {
    return iframeBody ? Math.floor(iframeBody.getBoundingClientRect().height) : 0;
}
function ResponsiveBanner(props) {
    var _a;
    const { className, response, properties, onTrackingEvent } = props;
    const { _opts } = properties;
    const [iframeRef, setIframeRef] = (0, react_1.useState)();
    const iframeWindow = iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.contentWindow;
    const iframeBody = iframeWindow === null || iframeWindow === void 0 ? void 0 : iframeWindow.document.body;
    const autoHide = _opts === null || _opts === void 0 ? void 0 : _opts.autohide;
    const responsiveHeight = (_opts === null || _opts === void 0 ? void 0 : _opts.responsive_height) || 'fit';
    const responsiveWidth = (_opts === null || _opts === void 0 ? void 0 : _opts.responsive_width) || 'fit';
    const contentSize = (0, commons_1.getContentSize)(properties, response);
    const position = responsiveHeight === 'dynamic' || responsiveWidth === 'dynamic' ? 'relative' : 'absolute';
    const width = responsiveWidth === 'fixed' ? contentSize.width + 'px' : '100%';
    const height = responsiveHeight === 'fixed' ? contentSize.height + 'px' : responsiveHeight === 'dynamic' ? 'auto' : '100%';
    const adContent = (0, react_1.useMemo)(() => {
        const cssText = `<style>\n` +
            `html, body { width: ${width}; height: ${height}; }\n` +
            `#revjet_container { width: ${width} !important; height: ${height} !important; }\n` +
            `#revjet_container > div { width: ${width} !important; height: ${height} !important; }\n` +
            `</style>`;
        return (0, commons_1.getAdContent)(properties, response).replace('</head>', cssText + '</head>');
    }, [properties, response, width, height]);
    const elementsProperties = (0, use_elements_props_1.useElementsProps)(iframeRef, adContent);
    const elementsInitialized = elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.initialized;
    const hideCreative = (elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.isEmptyPersonalization) || ((_a = elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.options) === null || _a === void 0 ? void 0 : _a.hideCreative);
    const [dynamicHeightStyle, setDynamicHeightStyle] = (0, react_1.useState)(EmptyStyle);
    const [autoHideStyle, setAutoHideStyle] = (0, react_1.useState)(autoHide ? HiddenStyle : EmptyStyle);
    (0, react_1.useEffect)(() => {
        if (!autoHide) {
            setAutoHideStyle(EmptyStyle);
        }
    }, [autoHide]);
    (0, react_1.useEffect)(() => {
        if (responsiveHeight !== 'dynamic') {
            setDynamicHeightStyle(EmptyStyle);
        }
    }, [responsiveHeight]);
    const iframeRefCallback = (0, react_1.useCallback)((iframeNode) => {
        setIframeRef(iframeNode);
    }, []);
    const resizeIframe = (responsiveHeight, iframeBody) => {
        if (iframeWindow && responsiveHeight === 'dynamic') {
            const newIframeHeight = calcIframeHeight(iframeBody);
            if (newIframeHeight > 0) {
                setDynamicHeightStyle({ height: newIframeHeight + 'px' });
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (autoHide) {
            if (!elementsInitialized) {
                setAutoHideStyle(HiddenStyle);
            }
            else if (elementsInitialized && !hideCreative) {
                setAutoHideStyle(EmptyStyle);
            }
        }
    }, [elementsInitialized, autoHide, hideCreative]);
    (0, use_tracking_event_listener_1.useTrackingEventListener)(!!elementsInitialized, iframeRef, onTrackingEvent);
    (0, react_1.useEffect)(() => {
        if (elementsInitialized &&
            responsiveHeight === 'dynamic' &&
            (!autoHide || !hideCreative) &&
            iframeBody &&
            iframeWindow &&
            iframeWindow.ResizeObserver) {
            const ro = new iframeWindow.ResizeObserver((entries) => {
                for (let entry of entries) {
                    if (entry['target'] === iframeBody) {
                        const newIframeHeight = calcIframeHeight(iframeBody);
                        if (newIframeHeight > 0) {
                            setDynamicHeightStyle({ height: newIframeHeight + 'px' });
                        }
                    }
                }
            });
            ro.observe(iframeBody);
            return () => ro.unobserve(iframeBody);
        }
        return undefined;
    }, [elementsInitialized, iframeBody, iframeWindow, responsiveHeight, autoHide, hideCreative]);
    const onIframeLoad = (0, react_1.useCallback)(() => {
        if (!autoHide || (elementsInitialized && !hideCreative)) {
            resizeIframe(responsiveHeight, iframeBody);
        }
    }, [autoHide, elementsInitialized, hideCreative, iframeBody, responsiveHeight]);
    const containerStyleSheet = (0, react_1.useMemo)(() => ({
        display: 'block',
        padding: '0',
        margin: '0',
        overflow: 'hidden',
        border: 'none',
        position: position,
        width: width,
        height: height,
        ...autoHideStyle
    }), [position, width, height, autoHideStyle]);
    const iframeStyleSheet = (0, react_1.useMemo)(() => ({
        display: 'block',
        border: 'none',
        padding: '0',
        margin: '0',
        top: '0',
        bottom: '0',
        left: '0',
        position: position,
        width: width,
        height: height,
        ...dynamicHeightStyle
    }), [position, width, height, dynamicHeightStyle]);
    const encodedSlotOptions = (0, react_1.useMemo)(() => (0, commons_1.getEncodedSlotOptions)(_opts), [_opts]);
    return (react_1.default.createElement("div", { style: containerStyleSheet, className: className },
        react_1.default.createElement("iframe", { ref: iframeRefCallback, onLoad: onIframeLoad, style: iframeStyleSheet, frameBorder: 0, marginWidth: 0, marginHeight: 0, scrolling: "no", loading: "eager", "data-options": encodedSlotOptions, srcDoc: adContent, ...AdditionalIframeProps })));
}
exports.ResponsiveBanner = ResponsiveBanner;
//# sourceMappingURL=responsive-banner.js.map